const API_URL = process.env.REACT_APP_API_URL || "https://api.k-martrwanda.com";

/** Storefront branding (override via env when deploying) */
export const SITE_NAME = process.env.REACT_APP_SITE_NAME || "K-Shop";
export const SITE_NAME_FULL = process.env.REACT_APP_SITE_NAME_FULL || "K-Shop";
export const SITE_DESCRIPTION =
  process.env.REACT_APP_SITE_DESCRIPTION ||
  "K-Shop — curated products from Asia, shipped with care.";

export function getPublicOrigin() {
  const fromEnv = process.env.REACT_APP_PUBLIC_URL;
  if (fromEnv) {
    return fromEnv.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return "";
}

export function getReferralLink(referralCode) {
  const base = getPublicOrigin();
  return base ? `${base}/?rf=${referralCode}` : `/?rf=${referralCode}`;
}

/** Shown on invoices / help text; set in .env for production */
export const SUPPORT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || "support@k-shop.com";

export { API_URL };
